import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../../theme/css/theme.css";
import { activeState } from "../../../theme/activeState";

export const chatStyle = recipe({
  base: {
    cursor: "pointer",
    width: "100%",
    borderRadius: theme.borderRadiuses.xxs,
    selectors: {
      "&:hover": {
        textDecoration: "underline",
      },
      "&:active": {
        ...activeState,
      },
    },
  },
  variants: {
    active: {
      true: {
        textDecoration: "underline",
      },
    },
  },
});
